@let resourceKindVal = resourceKind();
@let itemsVal = items();

@if (itemsVal.length > 0) {
  <rt-select2
    #select
    [formControl]="control()!"
    [items]="itemsVal!"
    [itemsLoading]="itemsLoading()"
    withMultiselect
    withSearch
  >
    <rt-select-trigger-multi [placeholder]="placeholder()!" />
    <ng-template [rtSelectSelectedItem]="select" let-remove="remove" let-item="item">
      <rt-chips [text]="item.label" [showClose]="true" (close)="remove(item)">
        @if (resourceKindVal === HiringResourceKind.Job) {
          <rt-offer-status-indicator
            [offerStatus]="{ kind: 'job', status: item.value.status }"
            prefix
          />
        }
        @if (resourceKindVal === HiringResourceKind.TalentPool) {
          <rt-icon name="nav-talent-pools-outline" prefix />
        }
      </rt-chips>
    </ng-template>
    <ng-template rtSelectSelectedItemCounter let-hiddenCount="hiddenCount">
      <rt-chips [text]="'+' + hiddenCount" [showClose]="false" />
    </ng-template>
    <ng-template
      [rtSelectListItem]="select"
      let-selectCtrl
      let-item="item"
      let-isHoverState="isHoverState"
      let-index="index"
    >
      <rt-dropdown-item (click)="selectCtrl.select$.next(item)" [class.hover]="isHoverState">
        <rt-checkbox
          prefix
          [checked]="selectCtrl.itemSelector.isSelected(item)"
          [hasMargin]="false"
          (valueChange)="selectCtrl.select$.next(item)"
        />
        @if (resourceKindVal === HiringResourceKind.Job) {
          <div layout>
            <div margin-left-small-x>
              <rt-offer-status-indicator
                [offerStatus]="{ kind: 'job', status: item.value.status }"
              />
            </div>
            <div layout-vertical margin-left-small-x>
              <span>{{ item.label }}</span>
              <div layout text-small text-color text-default>
                @if (item.value.department) {
                  {{ item.value.department }}
                }
                @if (item.value.department && item.value.locations.length !== 0) {
                  <rt-divider variant="dot" />
                }
                {{ resolveLocation(item.value.locations!) }}
              </div>
            </div>
          </div>
        }

        @if (resourceKindVal === HiringResourceKind.TalentPool) {
          <div layout>
            <div margin-left-small-xx>
              <rt-icon
                name="nav-talent-pools-outline"
                [hasAutoHeight]="true"
                margin-top-small-xxx
              />
            </div>
            <div layout-vertical margin-left-small-xx>
              <span>{{ item.label }}</span>
              <div layout text-small text-color text-default>
                {{ item.value.department }}
              </div>
            </div>
          </div>
        }
      </rt-dropdown-item>
    </ng-template>
  </rt-select2>
}

@if (itemsVal.length === 0 && !itemsLoading()) {
  <rt-select2 [formControl]="control()!" withMultiselect>
    @if (resourceKindVal === HiringResourceKind.Job) {
      <rt-select-empty-state
        [iconName]="'nav-jobs-filled'"
        [title]="'tlc.assign_members_to_jobs.dialog.jobs.empty_state.title' | translate"
        [desc]="'tlc.assign_members_to_jobs.dialog.jobs.empty_state.desc' | translate"
      />
    }

    @if (resourceKindVal === HiringResourceKind.TalentPool) {
      <rt-select-empty-state
        [iconName]="'nav-talent-pools-outline'"
        [title]="'tlc.assign_members_to_jobs.dialog.talent_pools.empty_state.title' | translate"
        [desc]="'tlc.assign_members_to_jobs.dialog.talent_pools.empty_state.desc' | translate"
      />
    }
  </rt-select2>
}
